<template>

<div class="logic">
        
    <slot></slot>

</div>

</template>

<script>

export default {

}

</script>

<style scoped>

.logic {
    background-color: #22465A;
    padding: 10px;
    display: flex;
    justify-content: center;
    border-radius: 0px 0px 10px 10px;
}

.is-mobile .logic {
    background-color: #fff;
    border: 1px solid #eee;
    border-top: 0px;
}

.logic >>> .logic-text {
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    height: 40px;
    color: #fff;
    padding: 0px 10px;
    line-height: 40px;
    text-align: center;
}

.is-mobile .logic >>> .logic-text {
    color: #343434;
}

.logic >>> .logic-text:first-child {
    padding-left: 0px;
}

.logic:empty {
    display: none;
}

</style>